/*
  * Show on all e-commerce-enabled articles and also if hideProductRecommendations is not set
 */
export const shouldShowProductBacon = (article) => (
  Boolean(article.ecommerceEnabled) && !article?.presentation?.hideProductRecommendations
);
